import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { Answer } from 'models/Answer'

// Define the initial state for the slice
const initialState: Record<number | string, Answer> = {}

// Define the `answers` slice
export const answersSlice = createSlice({
  name: 'answers',
  initialState,
  reducers: {
    // Reducer to add an answer to the map
    addAnswer: (state, action: PayloadAction<Answer>) => {
      const { questionId, answer, formId } = action.payload
      state[questionId] = { questionId, answer, formId }
    },
    // Reducer to remove an answer from the map
    removeAnswer: (state, action: PayloadAction<number | string>) => {
      const questionId = action.payload
      delete state[questionId]
    },
  },
})

// Export the `addAnswer` and `removeAnswer` actions
export const { addAnswer, removeAnswer } = answersSlice.actions

// Export the `answers` reducer
export default answersSlice.reducer
